// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"0811635581c92f925254","655":"a0bf420b118d3b171fe9"}[chunkId] + ".js";
};